var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-date"
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentStyle === "countdown"
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-date-countdown"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "days"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number"
                                },
                                [_vm._v(_vm._s(_vm.countdownDays))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownDays === "01",
                                      expression: "countdownDays === '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-sg"
                                },
                                [_c("translate", [_vm._v("Tag")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownDays !== "01",
                                      expression: "countdownDays !== '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-pl"
                                },
                                [_c("translate", [_vm._v("Tage")])],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "hours"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number"
                                },
                                [_vm._v(_vm._s(_vm.countdownHours))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownHours === "01",
                                      expression: "countdownHours === '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-sg"
                                },
                                [_c("translate", [_vm._v("Stunde")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownHours !== "01",
                                      expression: "countdownHours !== '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-pl"
                                },
                                [_c("translate", [_vm._v("Stunden")])],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "minutes"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number"
                                },
                                [_vm._v(_vm._s(_vm.countdownMinutes))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownMinutes === "01",
                                      expression: "countdownMinutes === '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-sg"
                                },
                                [_c("translate", [_vm._v("Minute")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownMinutes !== "01",
                                      expression: "countdownMinutes !== '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-pl"
                                },
                                [_c("translate", [_vm._v("Minuten")])],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-countdown-digit",
                              attrs: {
                                "data-countdown": "seconds"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-countdown-number"
                                },
                                [_vm._v(_vm._s(_vm.countdownSeconds))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownSeconds === "01",
                                      expression: "countdownSeconds === '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-sg"
                                },
                                [_c("translate", [_vm._v("Sekunde")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.countdownSeconds !== "01",
                                      expression: "countdownSeconds !== '01'"
                                    }
                                  ],
                                  staticClass: "cw-date-countdown-label-pl"
                                },
                                [_c("translate", [_vm._v("Sekunden")])],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentStyle === "date"
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-date-date"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-date-digits",
                              attrs: {
                                "data-date": "date"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-date-number"
                                },
                                [_vm._v(_vm._s(_vm.currentDeDate))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "cw-date-date-space"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-date-date-digits",
                              attrs: {
                                "data-date": "time"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "cw-date-date-number"
                                },
                                [_vm._v(_vm._s(_vm.currentTime))]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ]
              },
              proxy: true
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Datum")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentDate,
                                    expression: "currentDate"
                                  }
                                ],
                                attrs: {
                                  type: "date"
                                },
                                domProps: {
                                  value: _vm.currentDate
                                },
                                on: {
                                  change: _vm.computeTimestamp,
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentDate = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Uhrzeit")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTime,
                                    expression: "currentTime"
                                  }
                                ],
                                attrs: {
                                  type: "time"
                                },
                                domProps: {
                                  value: _vm.currentTime
                                },
                                on: {
                                  change: _vm.computeTimestamp,
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTime = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Layout")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentStyle,
                                      expression: "currentStyle"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentStyle = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "countdown"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Countdown")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "date"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Datum")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("translate", [_vm._v("Informationen zum Termin-Block")])
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }